import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { FundingProviderError } from '../provider-error.js';
export function useFundingCardAddition(onComplete) {
  const $ = _c(3);
  const [active, setActive] = useState(true);
  const accepting = useRef(true);
  let t0;
  if ($[0] !== active || $[1] !== onComplete) {
    t0 = {
      cardEntryActive: active,
      cardEntryEvent(event) {
        if (!accepting.current || event.kind === "ready") {
          return;
        }
        accepting.current = false;
        setActive(false);
        if (event.kind === "complete") {
          onComplete();
        }
      },
      retry() {
        accepting.current = true;
        setActive(true);
      }
    };
    $[0] = active;
    $[1] = onComplete;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
export function useFundingCardRemoval(provider, onRemoved, onFailure) {
  const [selected, setSelected] = useState(null);
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);
  const submitting = useRef(false);
  const alive = useRef(true);
  useEffect(() => {
    alive.current = true;
    return () => {
      alive.current = false;
    };
  }, []);
  return {
    selected,
    pending,
    failed,
    select(card) {
      if (submitting.current) return;
      setSelected(card);
      setFailed(false);
    },
    async confirm() {
      if (submitting.current || !selected?.allowsDeletion || !provider.deletePaymentMethod) return;
      submitting.current = true;
      setPending(true);
      setFailed(false);
      try {
        const result = await provider.deletePaymentMethod(selected.id);
        if (!result.ok) throw new FundingProviderError(result.error);
        if (alive.current) {
          setSelected(null);
          onRemoved();
        }
      } catch (error) {
        if (alive.current) {
          setFailed(true);
          onFailure(error instanceof FundingProviderError ? error.failure.code : 'provider_unavailable');
        }
      } finally {
        submitting.current = false;
        if (alive.current) setPending(false);
      }
    }
  };
}